import { AssetClass } from "types/AssetClass";
import { Distribution } from "types/Distribution";
import { createCustomAction } from "typesafe-actions";

const DISTRIBUTIONS_DATA_LOAD = "DISTRIBUTIONS/DISTRIBUTIONS_DATA_LOAD";
const DISTRIBUTIONS_DATA_LOAD_SUCCESS = "DISTRIBUTIONS/DISTRIBUTIONS_DATA_LOAD_SUCCESS";
const DISTRIBUTIONS_DATA_LOAD_FAIL = "DISTRIBUTIONS/DISTRIBUTIONS_DATA_LOAD_FAIL";

export type DistributionContentType = "all" | keyof typeof AssetClass;

export const load = createCustomAction(
  DISTRIBUTIONS_DATA_LOAD,
  (type) => (contentType: DistributionContentType, distribution: 1 | 2 | 3) => ({
    type,
    contentType,
    distribution,
  })
);

export const loadSuccess = createCustomAction(
  DISTRIBUTIONS_DATA_LOAD_SUCCESS,
  (type) => (
    contentType: DistributionContentType,
    distribution: 1 | 2 | 3,
    data?: Distribution[]
  ) => ({
    type,
    contentType,
    data,
    distribution,
  })
);

export const loadFail = createCustomAction(
  DISTRIBUTIONS_DATA_LOAD_FAIL,
  (type) => (contentType: DistributionContentType, distribution: 1 | 2 | 3, error?: string) => ({
    type,
    contentType,
    error,
    distribution,
  })
);
